// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/Users/stony/Documents/AppHelloRobotaxiWebsite/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index')}),
    "routes": [
      {
        "path": "/",
        "exact": true,
        "redirect": "/home"
      },
      {
        "path": "/home",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home__index' */'@/pages/home/index')})
      },
      {
        "path": "/technology",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technology__index' */'@/pages/technology/index')})
      },
      {
        "path": "/partnership",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__partnership__index' */'@/pages/partnership/index')})
      },
      {
        "path": "/experience-robotaxi",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__experience-robotaxi__index' */'@/pages/experience-robotaxi/index')})
      },
      {
        "path": "/news-guangzhou",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__news__index' */'@/pages/news/index')})
      },
      {
        "path": "/news-alipay",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__news__index' */'@/pages/news/index')})
      },
      {
        "path": "/news-praise",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__news__index' */'@/pages/news/index')})
      },
      {
        "path": "/news-hk",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__news__index' */'@/pages/news/index')})
      },
      {
        "path": "/*",
        "redirect": "/home",
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
